module.exports = __webpack_public_path__ + "static/media/ecos_kopenhagen_2_1.c6157ada.jpg";